import { render, staticRenderFns } from "./addXiangqing.vue?vue&type=template&id=dfb193c4&scoped=true&"
import script from "./addXiangqing.vue?vue&type=script&lang=js&"
export * from "./addXiangqing.vue?vue&type=script&lang=js&"
import style0 from "./addXiangqing.vue?vue&type=style&index=0&id=dfb193c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb193c4",
  null
  
)

export default component.exports